<template>
    <transition name="fade">
        <div class="ForceDisconnect" v-show="forcedDisconnectDialogueVisible" @click="toggleforcedDisconnectDialogue()">
            <div class="fd-container" @click="$event.stopPropagation()"><!--stopPropagation so toggleforcedDisconnectDialogue() wont trigger on dialogue itself -->
                <AlertCircleOutline/>
                <h1 class="fd-title"> {{ $t('Ein Moderator hat die Session für Sie geschlossen!') }}</h1>
            </div>         
        </div>  
    </transition>
</template>

<style scoped>
    .ForceDisconnect{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        background: #000000d0;
    }
    .fd-container{
        position: absolute;
        margin-top: 50px;
        background: white;
        border-radius: 10px;
        padding: 20px 50px;
        text-align: center;
    }
    .fd-title{
        margin-top: 20px;
        font-size: 18px;
    }
    .material-design-icon{
        width: 70px;
        height: 70px;
    }
    .material-design-icon > .material-design-icon__svg {
        width: 70px;
        height: 70px;
        fill: red;
    }
</style>
    
<script>
import {mapMutations,mapState,mapGetters} from 'vuex';
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue'


export default {
    components:{AlertCircleOutline},
    inject: ['toggleCommunication','toggleLogin'],
    data: function () {
        return {
            forcedDisconnectDialogueVisible: false,
        }
    }, 
    computed: {
        ...mapState({session: (state) => state.session.openTokSession}), 
        ...mapGetters(['users','localUserID']),
    },
	methods: {
        ...mapMutations(["dialogueOpen",'setIsOnboardingComplete','removeUser']),
        
        // Toggles visibility of this dialogue
        toggleforcedDisconnectDialogue(){
            this.forcedDisconnectDialogueVisible=!this.forcedDisconnectDialogueVisible;
            this.dialogueOpen(this.forcedDisconnectDialogueVisible);
        },
    },
    watch: {
        // Adds sessionDisconnected listener to created session
        // Listens to a forcedDisconnected Event which gets fired when a moderator removes a User
        session: function(){
            if(this.session){
                this.session.on("sessionDisconnected", (event)  => {
                    if(event.reason == "forceDisconnected"){                    
                        // Remove old users
                        this.users.forEach((u) => {
                            if(u.id !== this.localUserID)
                                this.removeUser(u.id);
                        });
                        
                        // Toggle this dialoge to inform user he got removed by a moderator
                        this.toggleforcedDisconnectDialogue();

                        // Toggle sidebar and LoginDialogue
                        this.toggleCommunication();
                        this.toggleLogin();
                        this.setIsOnboardingComplete(false);
                    }
                });
            }
        }
    }
}

</script>